import { csrfFetch } from "../utils/csrfFetch";

// Action Types
const LOAD_AUDIT_LOGS = "auditLogs/LOAD_AUDIT_LOGS";
const GET_AUDIT_LOG_DETAIL = "auditLogs/GET_AUDIT_LOG_DETAIL";

// Action Creators
export const loadAuditLogs = (logs) => ({
  type: LOAD_AUDIT_LOGS,
  payload: logs,
});

export const getAuditLogDetail = (log) => ({
  type: GET_AUDIT_LOG_DETAIL,
  payload: log,
});

// Thunks
export const fetchAuditLogs = () => async (dispatch) => {
  try {
    const response = await csrfFetch("/api/admin/audit-logs");
    if (response.ok) {
      const logs = await response.json();
      dispatch(loadAuditLogs(logs));
      return logs;
    }
  } catch (error) {
    console.error("Error fetching audit logs:", error);
    throw error;
  }
};

export const fetchAuditLogDetail = (logId) => async (dispatch) => {
  try {
    const response = await csrfFetch(`/api/admin/audit-logs/${logId}`);
    if (response.ok) {
      const log = await response.json();
      dispatch(getAuditLogDetail(log));
      return log;
    }
  } catch (error) {
    console.error("Error fetching audit log detail:", error);
    throw error;
  }
};

// Reducer
const initialState = {
  logs: [],
  currentLog: null
};

export default function auditLogsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_AUDIT_LOGS:
      return {
        ...state,
        logs: action.payload
      };
    case GET_AUDIT_LOG_DETAIL:
      return {
        ...state,
        currentLog: action.payload
      };
    default:
      return state;
  }
}
